import { http } from '@/lib'
import { useAsyncFn } from '@clara/hooks'

export async function deleteAttachment(docId: string) {
  return http.delete('/attachment/' + docId).then((response) => response.data)
}

export function useDeleteAttachment() {
  return useAsyncFn(async (docId: string) => {
    const response = await deleteAttachment(docId)
    return response
  }, [])
}
